import { useEffect, useState } from 'react';
import Button from '../../../external/components/Button/Button';
import { Skeleton } from '../../../external/components/SkeletonLoading/Skeleton';
import Text from '../../../external/components/Text/Text';
import { ProviderRpcError } from '../../../types/metamask.types';
import { timeHelpers } from '../helpers/timeHelpers';
import { useLPStakingActions } from '../hooks/useLpStakingActions';
import { useLpStakingData } from '../hooks/useLpStakingData';
import { UseLpStakingPool } from '../hooks/usePool';
import { LpScreenEnum } from './_Screens';

interface Props {
  setClaimedAmount: React.Dispatch<React.SetStateAction<string>>;
  setScreen: React.Dispatch<React.SetStateAction<LpScreenEnum>>;
}

export function ClaimConfirm({ setClaimedAmount, setScreen }: Props) {
  const [loading, setLoading] = useState(false);

  const pool = UseLpStakingPool();

  const { claimRewards } = useLPStakingActions({ pool });
  const [withdrawLoading, setWithdrawLoading] = useState(false);
  const [withdrawErrors, setWithdrawErrors] = useState('');

  const { unlockingTime, rewardBalance, rewardTokenSymbol } = pool;

  const handleClaim = async () => {
    if (rewardBalance) {
      try {
        setWithdrawErrors('');
        setWithdrawLoading(true);
        await claimRewards(rewardBalance);
        setClaimedAmount(rewardBalance);
        setWithdrawLoading(false);
        setScreen(LpScreenEnum.CLAIM_SUCCESS);
      } catch (_error) {
        const error = _error as ProviderRpcError;
        if (error.code === -32603) {
          setWithdrawErrors(
            'ERROR: Transaction underpriced. Please adjust transaction fees limit manually in your Wallet App.',
          );
          setWithdrawLoading(false);
          return;
        }
        setWithdrawErrors(error.message);
        setWithdrawLoading(false);
      }
    }
  };

  const { getRewardsEarned } = useLpStakingData({ pool });

  const initData = async () => {
    try {
      setLoading(true);
      await getRewardsEarned();
      setLoading(false);
    } catch (error) {
      //@FIX HANDle errOR
    }
  };

  useEffect(() => {
    //@FIX call unclaimed rewards
    initData();
  }, []);

  return (
    <>
      <Button
        size='small'
        variant='secondary'
        dark={true}
        onClick={() => setScreen(LpScreenEnum.HOME_SCREEN)}
        disabled={withdrawLoading || loading}
      >
        ⬅
      </Button>
      <div className='flex direction-column align-center'>
        {withdrawErrors && <Text dark={true}>{withdrawErrors}</Text>}
        <Text color='lightgrey' style={{ margin: '0.5rem 0' }}>
          {' '}
          You are claiming
        </Text>
        {loading ? (
          <>
            <Skeleton width='250px' height='40px' dark={true} margin={'1.5rem 0 0 0'} />
          </>
        ) : (
          <Text dark={true} size='xxl' style={{ margin: '0.5rem 0' }}>
            {rewardBalance} {rewardTokenSymbol}
          </Text>
        )}
        <Text color='green' style={{ margin: '0.25rem 0 2rem' }}>
          {/* {unstakeData.usdAmount} USD @FIX */}
        </Text>

        <Text color='lightgrey' size='sm' style={{ margin: '0.25rem 0 2rem' }}>
          This will available for withrawal after a period of{' '}
          {timeHelpers.humaniseTime(parseInt(unlockingTime || '0'))}
        </Text>
        <Button
          dark={true}
          variant='primary'
          onClick={handleClaim}
          loading={withdrawLoading}
          disabled={withdrawLoading || loading}
        >
          {withdrawLoading ? 'Processing...' : 'Confirm withdraw'}
        </Button>
      </div>
    </>
  );
}
